import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeader from "@/components/shared/SectionHeader";
import { ADVISORY_AREAS, EISG_IMG } from "@/lib/data";

const EISGAdvisory = () => (
  <div>
    <section className="relative py-32 lg:py-40 bg-[#0A192F] text-white grain overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <img src={EISG_IMG.boardroom} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/90 to-transparent" />
      </div>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
        <div className="overline text-[#D4AF37] mb-6">— EISG Advisory & In-House</div>
        <h1 className="font-eisg text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
          Des solutions sur mesure pour <span className="text-[#D4AF37] italic">des résultats durables.</span>
        </h1>
        <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
          EISG accompagne les organisations publiques et privées dans la définition et la mise en œuvre de leur stratégie IA, de leur gouvernance et de leur feuille de route de transformation.
        </p>
      </div>
    </section>

    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionHeader number="— 01" eyebrow="Domaines d'intervention" title="Dix offres EISG Advisory & In-House." titleFont="eisg" />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0A192F]/10">
          {ADVISORY_AREAS.map((a, i) => (
            <div key={a} className="bg-white p-8 lift-card">
              <div className="font-eisg text-4xl text-[#D4AF37] leading-none">{String(i + 1).padStart(2, "0")}</div>
              <p className="mt-5 font-bd text-lg text-[#0A192F] leading-snug">{a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="py-24 bg-[#FAFAFA]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="overline text-[#0A192F]/60 mb-4">— 02 · Tarification</div>
          <h2 className="font-eisg text-4xl sm:text-5xl text-[#0A192F] tracking-tight leading-tight">
            Sur devis institutionnel.
          </h2>
          <p className="mt-6 text-[#0A192F]/75 text-lg leading-relaxed max-w-2xl">
            Chaque mandat EISG Advisory & In-House est calibré sur la base d'un cahier des charges institutionnel : périmètre, équipes, durée, livrables et indicateurs de succès.
          </p>
          <Link to="/eisg/contact" className="mt-8 btn-premium btn-premium-primary">
            Demander une proposition institutionnelle <ArrowRight size={16} />
          </Link>
        </div>
        <div className="lg:col-span-5">
          <img src={EISG_IMG.dashboard} alt="Advisory" className="w-full h-[400px] object-cover" />
        </div>
      </div>
    </section>
  </div>
);

export default EISGAdvisory;
